import React from 'react';
import { ButtonGroup, Button } from 'ui';
import { useToggle, useAutoFocus } from 'hooks';
import LinkButton from 'components/shared/LinkButton';
import Modal from 'components/shared/modal';

const DiscardButton = ({ onDiscard, disabled }) => {
  const [modalVisible, toggleModalVisible] = useToggle();
  const autoFocus = useAutoFocus();
  return (
    <>
      <LinkButton
        disabled={disabled}
        className="fz-bigger"
        onClick={toggleModalVisible}
      >
        {t('element_builder.discard_changes')}
      </LinkButton>
      <Modal
        show={modalVisible}
        dismissCallback={toggleModalVisible}
        title={t('element_builder.discard_changes_confirmation.title')}
      >
        <div className="mb-24">
          {t('element_builder.discard_changes_confirmation.are_you_sure')}{' '}
          <b>
            {t('element_builder.discard_changes_confirmation.cannot_be_undone')}
          </b>
        </div>
        <ButtonGroup alignEnd>
          <Button primary ref={autoFocus} onClick={toggleModalVisible}>
            {t('common.cancel')}
          </Button>
          <Button onClick={onDiscard}>
            {t('element_builder.discard_changes_confirmation.discard')}
          </Button>
        </ButtonGroup>
      </Modal>
    </>
  );
};

export default DiscardButton;
